import type {Intent} from '@sail/engine';
import {createObjectIntentType} from '@sail/engine';
import {mergeMotionProps} from './mergeMotionProps';
import type {MotionProps} from '../types';

export const createMotionProps = createObjectIntentType(
  'createMotionProps',
  (decorate) =>
    (obj: MotionProps): MotionProps & Intent =>
      decorate(obj),
  (target, source) => {
    mergeMotionProps(target, source);
  },
);
